import { render, staticRenderFns } from "./lvNavMenu.vue?vue&type=template&id=208c6d3b&scoped=true&"
import script from "./lvNavMenu.vue?vue&type=script&lang=js&"
export * from "./lvNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./lvNavMenu.vue?vue&type=style&index=0&id=208c6d3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208c6d3b",
  null
  
)

export default component.exports